import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

// Import your public page components
import DevelopersList from '../components/User/DevelopersList';
import TermsOfService from '../components/User/TermsOfService';
import PrivacyPolicy from '../components/User/PrivacyPolicy';
import ProjectDetail from '../components/User/ProjectDetail';
import DeveloperDetail from '../components/User/DeveloperDetail';
import HomePage from '../components/User/HomePage';

export default function UserRoutes() {
    return (
        <Routes>
            {/* Home */}
            <Route path="/" element={<HomePage />} />
            {/* Listings */}
            <Route path="/developers" element={<DevelopersList />} />
            {/* Static pages */}
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            {/* Dynamic detail views */}
            <Route path="/project/:slug" element={<ProjectDetail />} />
            <Route path="/developer/:slug" element={<DeveloperDetail />} />
            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
}
